import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Tabs, Tab, Panel, PanelGroup, Modal } from 'react-bootstrap';
import MediaQuery from 'react-responsive';
import AWS, { Connect } from 'aws-sdk';

import axios from '../../../services/axios-service';
import './profile.css';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import ProfileScoring from '../ProfileScoring/ProfileScoring';
import Feedback from '../Feedback/Feedback';
import * as actions from '../../../store/actions/index';
import CandidateOverview from '../../../components/Client/CandidateOverview/CandidateOverview';
import config from '../../../config';
import RecruiterComments from '../../../components/Client/RecruiterComments/RecruiterComments';
import Experience from '../../../components/Client/Experience/Experience';
import Skills from '../../../components/Client/Skills/skills';
import Languages from '../../../components/Client/Languages/Languages';
import Education from '../../../components/Client/Education/Education';
// import Training from '../../../components/Client/Training/Training';
import Hobby from '../../../components/Client/Hobby/Hobby';
import PrintCandidateProfile from '../../../components/Client/CandidateProfilePage/PrintCandidateProfile/PrintCandidateProfile';
import Button from '../../../components/UI/Button/Button';
import ToastNotification from '../../../components/UI/ToastNotification/ToastNotification';
// import createHistory from 'history/createBrowserHistory'
import ReactGA from 'react-ga';
// import ConsoleLog from './../../../hoc/ConsoleLog/ConsoleLog';
import Icon from '../../../components/UI/Icon/Icon';
// import ProgreesNotification from '../../../components/UI/ProgreesNotification/ProgreesNotification';
// import printCandidatePreview from '../../../components/Client/CandidateProfilePage/PrintCandidateProfile/PrintCandidateProfile';

const noDataString = "- Not Specified -";

/**
* @desc Candidate Profile section
* @version 1.0.1
* @author Jamshith ,Lakshmikanth,Praveen,Amrutha
*/
class Profile extends Component {
  state = {
    showModal: true,
    status: "",
    candidateId: "",
    regretReason: 1,
    profileTabKey: "recruiter",
    candidate_status: "",
    candidatePhoto: null,
    isShowToast: false,
    toastMessage: null,
    toastVariant: null,
    toastAutoClose: false,
    toastId: null,
    showNotification: null,
    horizontalLoader: true,
    jobChangedId: ''
  };

  progressCount = 0;

  /**
  * @desc redux call to get individual candidate data a according to activeCandidateId on loading the page.
  * @param null
  * @return null
  */
  componentDidMount() {
    // Decode entities in the URL
    // Sometimes a URL like #/foo#bar will be encoded as #/foo%23bar
    window.location.hash = window.decodeURIComponent(window.location.hash);
    const scrollToAnchor = () => {
      const hashParts = window.location.hash.split('#');
      if (hashParts.length > 2) {
        const hash = hashParts.slice(-1)[0];
        document.querySelector(`#${hash}`).scrollIntoView();
      }
    };
    scrollToAnchor();
    window.onhashchange = scrollToAnchor;
    if (this.props.jobTitleId && this.props.jobTitleId !== null) {
      this.setState({jobChangedId: this.props.jobTitleId});
      if (this.props.id && this.props.id !== "") {
        this.props.onGetProfileDetails(this.props.id, this.props.jobTitleId, true, this.props.user);
      } else {
        this.props.onGetProfileDetails(this.props.activeCandidateId, this.props.jobTitleId, true, this.props.user);
      }
      /* 
     The following is the React Google analytics code section for candidate profile views start point
     */
      const candidateId = this.props.activeCandidateId;
      ReactGA.initialize(config.GAId);
      ReactGA.pageview("/candidate/" + candidateId);
      //ConsoleLog("componentDidMount GA candidate: ", "/candidate/" + candidateId);
      /* 
      React Google analytics code section for candidate profile views end point
      */
    }

    if (this.props.profileInfo.message) {
      this.setState({ showModal: true });
    }

    if (this.props.pool.length > 0) {
      if (this.props.pool[0].interview_exists === 'no') {
        if (this.props.pool.filter((candidate) => candidate.candidate_status === "PROGRESS").length > 0) {
          localStorage.setItem('showNotification', true);
          this.setState({ showNotification: true });
        } else {
          localStorage.setItem('showNotification', false);
          this.setState({ showNotification: false });
        }
      }
    }

  }

  /**
  * @desc fetches the candidate data while moving to next candidate in the page
  * @param nextProps,nextState
  * @return null
  */
  componentDidUpdate(nextProps, nextState) {

    if (this.props.jobTitleId && this.props.jobTitleId !== null) {
      if (this.props.pool[0].candidate_id !== nextProps.pool[0].candidate_id && this.props.activeCandidateId === this.props.pool[0].candidate_id) {
        this.props.onGetProfileDetails(this.props.pool[0].candidate_id, this.props.jobTitleId, true, this.props.user);
      }
      if (nextProps.activeCandidateId !== this.props.activeCandidateId) {
        this.props.onGetProfileDetails(this.props.activeCandidateId, this.props.jobTitleId, true, this.props.user);

        if(this.state.jobChangedId !== this.props.jobTitleId){
          this.setState({ horizontalLoader: false, jobChangedId: this.props.jobTitleId });
        }else{
          this.setState({ horizontalLoader: true });
          setTimeout(() => {
            this.setState({ horizontalLoader: false });
          }, 2500);
          this.props.handleViewClick();
        }

        /* 
        The following is the React Google analytics code section for candidate views start point
        */
        const candidateId = this.props.activeCandidateId;
        ReactGA.initialize(config.GAId);
        ReactGA.pageview("/candidate/" + candidateId);
        //ConsoleLog("componentDidUpdate GA candidate: ", "/candidate/" + candidateId);
        /* 
        The following is the React Google analytics code section for candidate views end point
        */
      }
    }

    if (nextProps.profileInfo.candidatePhoto !== this.props.profileInfo.candidatePhoto) {
      if (this.props.profileInfo.candidatePhoto === null) {
        localStorage.removeItem("candidatePhoto");
        this.setState({ candidatePhoto: null });
      } else {
        this.getS3ImageUrl(this.props.profileInfo.candidatePhoto)
          .then((url) => {
            this.setState({ candidatePhoto: url });
          });
      }
    }
    if (this.props.profileInfo.message && this.props.profileInfo !== nextProps.profileInfo) {
      this.setState({ showModal: true });
    }
    if (this.props.profileInfo.hobbies && this.props.profileInfo.hobbies.length === 0 && this.state.profileTabKey == "hobbies") {
      this.setState({ profileTabKey: "recruiter" });
    }
    if (this.props.profileInfo.languages && this.props.profileInfo.languages.length === 0 && this.state.profileTabKey == "languages") {
      this.setState({ profileTabKey: "recruiter" });
    }
    if (this.props.pool !== nextProps.pool) {
      if (this.props.pool.length > 0) {
        if (this.props.pool[0].interview_exists === 'no') {
          if (this.props.pool.filter((candidate) => candidate.candidate_status === "PROGRESS").length > 0) {
            localStorage.setItem('showNotification', true);
            this.setState({ showNotification: true });
          } else {
            localStorage.setItem('showNotification', false);
            this.setState({ showNotification: false });
          }
        }
      }
    }

  }

  /**
  * @desc decides whether component should update according to the given condition
  * @param nextProps,nextState
  * @return null
  */
  shouldComponentUpdate(nextProps, nextState) {
    return (nextProps.profileInfo.candidate_id !== this.props.profileInfo.candidate_id ||
      this.state !== nextState ||
      this.props.pool !== nextProps.pool ||
      this.props.activeCandidateId !== nextProps.activeCandidateId);
    return true;
  }

  /**
* @desc changes the main tab selection
* @param null
* @return null
*/
  handleProfileTabSelect(key) {
    this.setState({ profileTabKey: key });
  }
  /**
  * @desc saves image url to localstorage
  * @param imageUrl
  * @return null
  */
  getS3ImageUrl = (imageUrl) => {
    AWS.config.update({
      region: config.cognito.region
    });

    let logins = {}
    logins['cognito-idp.' + config.cognito.region + '.amazonaws.com/' + config.cognito.userPool] = this.props.user.storage['CognitoIdentityServiceProvider.' + config.cognito.clientId + '.' + this.props.attributes.email + '.idToken'];
    // Add the User's Id Token to the Cognito credentials login map.
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: config.cognito.identityPool,
      Logins: logins
    });

    let S3 = new AWS.S3();
    return new Promise(function (resolve, reject) {
      S3.getSignedUrl('getObject', { Bucket: config.cognito.bucketName, Key: imageUrl }, function (err, data) {
        if (err) {
          localStorage.removeItem("candidatePhoto");
          reject(err);
        } else {
          localStorage.setItem("candidatePhoto", data);
          resolve(data);
        }
      });
    });
  }

  handlePrintProfileMobile = () => {
    var content = document.getElementById('print-preview');
    var pri = document.getElementById('ifmcontentstoprint').contentWindow;
    pri.document.open();
    pri.document.write("<div className='print-profile'>" + content.innerHTML + "</div>");
    pri.document.close();
    pri.focus();
    pri.print();
  }

  handleClosePopup = () => {
    if (this.props.jobTitleId && this.props.jobTitleId !== null) {
      this.props.onGetTalentPool(this.props.jobTitleId, this.props.user);
    }
    this.setState({ showModal: false });
  }
  /**
   * @desc cloase toast notification
   * @param null
   * @return null
   */
  handleCloseToastNotification = () => {
    this.setState({
      isShowToast: false,
      toastMessage: null,
      toastVariant: null,
      toastAutoClose: false
    })
  }
  /**
 * @desc regret scored candidate toast notification through scoring
 * @param null
 * @return null
 */
  handleRegret = (isShowToast, toastMessage, toastVariant) => {
    this.setState({
      isShowToast: isShowToast,
      toastMessage: toastMessage,
      toastVariant: toastVariant,
      toastId: "tid" + (new Date()).getTime()
    })
  }
  /**
 * @desc progress scored candidate toast notification through scoring
 * @param null
 * @return null
 */
  handleFeedBackStatus = (isShowToast, toastMessage, toastVariant) => {
    this.setState({
      isShowToast: isShowToast,
      toastMessage: toastMessage,
      toastVariant: toastVariant,
      toastId: "tid" + (new Date()).getTime()
    })
  }
  /**
 * @desc Evaluation comments saved toast notification
 * @param null
 * @return null
 */
  handlesaveFeedbackComment = (isShowToast, toastMessage, toastVariant) => {
    this.setState({
      isShowToast: isShowToast,
      toastMessage: toastMessage,
      toastVariant: toastVariant,
      toastId: "tid" + (new Date()).getTime()
    })
  }
  /**
  * @desc progress/regret feedback candidate toast notification 
  * @param null
  * @return null
  */
  handleProgress = (showToast, toastMessage, toastVariant) => {
    this.setState({
      isShowToast: showToast,
      toastMessage: toastMessage,
      toastVariant: toastVariant,
      toastId: "tid" + (new Date()).getTime()
    })
  }

  handleCloseNotification = () => {
    localStorage.setItem('showNotification', false);
    this.setState({ showNotification: false });
  }

  /**
  * @desc actual rendering of the component dom element
  * @param null
  * @return DOMElement
  */
  render() {
    const candidate_id = this.props.profileInfo.candidate_id;
    const activePoolCandidate = this.props.pool.find(e => e.candidate_id === candidate_id);
    let candidate = this.props.profileInfo;

    let jobDetails = this.props.talentPool;

    if (!candidate || candidate.length === 0) {
      return (null);
    }

    if (candidate && activePoolCandidate) {
      candidate.candidate_status = activePoolCandidate.candidate_status;
    }


    let viewClicked = false;
    if (this.props.viewClicked) {
      viewClicked = true;
    }

    if (candidate.message) {
      return (
        <Modal
          className="scoring-modal candidate-notfound-error"
          show={this.state.showModal}
          onHide={this.handleClosePopup}
        >
          <Modal.Header ></Modal.Header>
          <Modal.Body>
            <h1>Candidate Not Found!</h1>
            <p>Please click ok to continue.</p>
            <Button onClick={this.handleClosePopup}>OK</Button>
          </Modal.Body>
        </Modal>
      )
    }

    let languageLength = 0;
    if (candidate.languages.length > 0) {
      candidate.languages.map((lang) => {
        if (lang.language.length > 0) {
          languageLength++;
        }
      })
    }

    let skills = noDataString;
    var skillsArray = [];
    if (candidate.skills.length > 0) {

      for (let i = 0; i < candidate.skills.length; i = i + 3) {
        skillsArray.push(candidate.skills.slice(i, i + 3));
      }

      skills = skillsArray.map((items, index) => {
        const groupedItems = items.map((item, itemindex) => {
          return (
            <Skills key={itemindex} skill={item} />
          )
        })
        return (
          <div className="skillrow">
            {groupedItems}
          </div>
        )
      });

    }

    return (
      <div className="profile-cont">
        <MediaQuery query="(max-device-width: 800px)">
          {/* {this.state.showNotification && localStorage.getItem('showNotification') === 'true' ? 
            <ProgreesNotification handleCloseNotification={this.handleCloseNotification} handleMobileView={true} /> 
            : ""
          } */}
          <div className="job-header">
            <Icon icon="back-arrow-sharp-edge" className="back-arrow-sharp-edge" onClick={() => window.history.back()} />
            <p>Candidate list for <span>{jobDetails.jobTitle} - {jobDetails.jobTitleBHID}</span></p>
          </div>
        </MediaQuery>
        {
           candidate_id && this.props.viewClicked && this.state.horizontalLoader ?
            <div className="rec-profile-edit-loader">
              <div className="profile-tabs">
                <ul role="tablist" class="nav nav-tabs">
                  <li role="presentation" class="active">
                    <a href="#" style={{
                      width: '435px'
                    }}></a>
                  </li>
                </ul>
              </div>
              <div className="timeline-wrapper">
                <div class="candidate-overview">
                  <div class="profile-picture-container">
                    <div class="profile-picture">
                      <div class="Candidate-Photo-Container">
                        <div className="background-mask face-mask"></div>
                      </div>
                    </div>
                  </div>
                  <div class="details">
                    <h1 class="candidate-name"><div className="background-mask line-mask"></div></h1>
                    <div class="highlight-experience row">
                      <div class="col-md-6 col-xs-12"><div className="background-mask line-mask"></div></div>
                      <div class="col-md-6 col-xs-12"><div className="background-mask line-mask"></div></div>
                    </div>
                    <div class="email-wrapper">
                    </div>
                    <div>
                      <div class="line"></div>
                      <div class="prev-experience-container">
                        <h2 class="cs"><div className="background-mask line-mask"></div></h2>
                        <div class="show-grid previous-experience-content row">
                          <div class="col-md-12">
                            <div className="background-mask line-mask"></div>
                          </div>
                        </div>
                      </div>
                      <div class="lineb notice-period-line"></div>
                      <div class="row">
                        <div class="col-md-6 col-xs-12"><span class="notice"><div className="background-mask line-mask"></div></span></div>
                        <div class="col-md-6 col-xs-12"><span class="jobtype"><div className="background-mask line-mask"></div></span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            : <div className={"profile"}>
              <Tabs
                defaultActiveKey={1}
                id="uncontrolled-tab-example"
                className="profile-tabs"
                animation={false}
              >
                <Tab eventKey={1} title="Profile">
                  <CandidateOverview
                    {...this.props}
                    candidate={candidate}
                    candidate_id={candidate_id}
                    candidate_status={candidate.candidate_status}
                    handleProfileTabSelect={this.handleProfileTabSelect.bind(this)}
                    jobTitleId={this.props.jobTitleId}
                    open={this.open}
                    user={this.props.user}
                    attributes={this.props.attributes}
                    candidatePhoto={this.state.candidatePhoto}
                    isS3Url={(this.state.candidatePhoto !== null) ? true : false}
                    handlePrintProfileMobile={this.handlePrintProfileMobile}
                  />

                  <MediaQuery query="(max-device-width: 767px)">
                    <PanelGroup
                      activeKey={this.state.profileTabKey}
                      onSelect={this.handleProfileTabSelect.bind(this)}
                      accordion
                      id="profile-accordion"
                    >
                      <Panel eventKey="recruiter">
                        <Panel.Heading>
                          <Panel.Title toggle>Recruiter's Comments</Panel.Title>
                        </Panel.Heading>
                        <Panel.Body collapsible>
                          <ul className="recruiter-comments">
                            {(candidate.recruiter_comments) ? candidate.recruiter_comments.split('\n').map((comments, index) => (
                              comments ? <RecruiterComments key={index} text={comments} /> : null
                            )) : noDataString}
                          </ul>
                        </Panel.Body>
                      </Panel>
                      <Panel eventKey="experience">
                        <Panel.Heading>
                          <Panel.Title toggle>Experience</Panel.Title>
                        </Panel.Heading>
                        <Panel.Body collapsible>
                          {(candidate.experience && candidate.experience.length > 0) ? candidate.experience.map((exp, index) => (
                            <Experience key={index} {...exp} />
                          )) : noDataString}
                        </Panel.Body>
                      </Panel>
                      <Panel eventKey="skills">
                        <Panel.Heading>
                          <Panel.Title toggle>Skills</Panel.Title>
                        </Panel.Heading>
                        <Panel.Body collapsible>
                          <Row>
                            {(candidate.skills.length > 0) ? candidate.skills.map((skill, index) => (
                              <Skills key={index} skill={skill} />
                            )) : noDataString}
                          </Row>
                        </Panel.Body>
                      </Panel>
                      <Panel eventKey="education">
                        <Panel.Heading>
                          <Panel.Title toggle>Education and Training</Panel.Title>
                        </Panel.Heading>
                        <Panel.Body collapsible>
                          <Tabs
                            defaultActiveKey="education"
                            id="education-tabs"
                          >
                            <Tab eventKey="education" title="Education">
                              {(candidate.education.filter((edu) => { return edu.isTraining == 0; }).length > 0) ? candidate.education.filter((edu) => { return edu.isTraining == 0; }).map((edu, index) => (
                                <Education key={index} {...edu} />
                              )) : noDataString}
                            </Tab>
                            <Tab eventKey="training" title="Training">
                              {(candidate.education.filter((edu) => { return edu.isTraining == 1; }).length > 0) ? candidate.education.filter((edu) => { return edu.isTraining == 1; }).map((train, index) => (
                                <Education key={index} {...train} />
                              )) : noDataString}
                            </Tab>
                          </Tabs>
                        </Panel.Body>
                      </Panel>
                      {languageLength > 0 ?
                        <Panel eventKey="languages">
                          <Panel.Heading>
                            <Panel.Title toggle>Languages</Panel.Title>
                          </Panel.Heading>
                          <Panel.Body collapsible>
                            {(candidate.languages.length > 0) ? candidate.languages.map((lang, index) => (
                              <Languages key={index} {...lang} />
                            )) : noDataString}
                          </Panel.Body>
                        </Panel> : ""}
                      {(candidate.hobbies.length > 0) ?
                        <Panel eventKey="hobbies" ref={(section) => { this.Experience = section; }}>
                          <Panel.Heading>
                            <Panel.Title toggle>Interests</Panel.Title>
                          </Panel.Heading>
                          <Panel.Body collapsible>
                            {candidate.hobbies.map((hobby, index) => (
                              <Hobby key={index} hobby={hobby} />
                            ))}
                          </Panel.Body>
                        </Panel>
                        : ""}
                    </PanelGroup>
                  </MediaQuery>
                  <MediaQuery query="(min-device-width: 768px)">
                    <Tabs
                      className={(candidate.hobbies.length > 0) ? "profile-sub-tabs" : "profile-sub-tabs"}
                      activeKey={this.state.profileTabKey}
                      onSelect={this.handleProfileTabSelect.bind(this)}
                      id="profile-tabs"
                      animation={false}
                    >
                      {/* Highlights Tab Starts*/}
                      <Tab eventKey="recruiter" title={<span>Recruiter's Comments</span>}>
                        <div id="tab1">
                          <div className="panel panel-default">
                            <div id="collapseOne" className="panel-collapse collapse in">
                              <div className="panel-body rec">
                                {(candidate.recruiter_comments) ? candidate.recruiter_comments.split('\n').map((comments, index) => (
                                  comments ? <RecruiterComments key={index} text={comments} /> : null
                                )) : noDataString}
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab>
                      {/* Highlights Tab Ends*/}

                      {/* Experience Tab Starts*/}
                      <Tab eventKey="experience" title={<span>Experience</span>} >
                        <div id="tab2">
                          <div className="panel panel-default">
                            <div id="collapseTwo" className="panel-collapse collapse">
                              <div className="panel-body">
                                {(candidate.experience.length > 0) ? candidate.experience.map((exp, index) => (
                                  <Experience key={index} {...exp} />
                                )) : noDataString}
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab>
                      {/* Experience Tab Ends*/}

                      {/* Skills Tab Starts*/}
                      <Tab eventKey="skills" title={<span>Skills</span>}>
                        <div id="tab3">
                          <div className="panel panel-default">
                            <div id="collapseThree" className="panel-collapse collapse">
                              <div className="panel-body ski">
                                {/* <h2>My Skills</h2> */}
                                {skills}
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab>
                      {/* Skills Tab Ends*/}

                      {/* Education Tab Starts*/}
                      <Tab eventKey="education" title={<span>Education and Training</span>}>
                        <div id="tab4">
                          <div className="panel panel-default">
                            <div id="collapseFour" className="panel-collapse collapse">
                              <div className="panel-body">
                                {((candidate.education.filter((edu) => edu.isTraining == 0).length > 0) && (candidate.education.filter((edu) => edu.isTraining == 1).length > 0)) ?
                                  <div className="col-md-8 col-xs-offset-4">
                                    <ul role="tablist" className="nav nav-tabs">
                                      <li role="presentation" className="active">
                                        <a data-toggle="tab" href="#tab-education">Education</a>
                                      </li>
                                      <li role="presentation" className="">
                                        <a data-toggle="tab" href="#tab-training">Training</a>
                                      </li>
                                    </ul>
                                  </div>
                                  :
                                  ((candidate.education.filter((edu) => edu.isTraining == 0).length === 0) && (candidate.education.filter((edu) => edu.isTraining == 1).length === 0)) ?
                                    noDataString : ""
                                }
                                <div className="clearfix"></div>
                                {((candidate.education.filter((edu) => edu.isTraining == 0).length > 0) && (candidate.education.filter((edu) => edu.isTraining == 1).length > 0)) ?
                                  <Tabs
                                    defaultActiveKey="education"
                                    id="eduation-tabs"
                                    animation={false}
                                  >
                                    <div className="tab-pane active" id="tab-education">
                                      <Tab eventKey="education" title="Education">
                                        {candidate.education.filter((edu) => { return edu.isTraining == 0; }).map((edu, index) => (
                                          <Education key={index} {...edu} />
                                        ))}
                                      </Tab>
                                    </div>
                                    <div className="tab-pane" id="tab-training">
                                      <Tab eventKey="training" title="Training">
                                        {candidate.education.filter((edu) => { return edu.isTraining == 1; }).map((train, index) => (
                                          <Education key={index} {...train} />
                                        ))}
                                      </Tab>
                                    </div>

                                  </Tabs>
                                  :
                                  <div>
                                    {(candidate.education.filter((edu) => edu.isTraining == 0).length > 0) && (
                                      <div className="tab-pane active" id="tab-education">
                                        {candidate.education.filter((edu) => { return edu.isTraining == 0; }).map((edu, index) => (
                                          <Education key={index} {...edu} />
                                        ))}
                                      </div>)}
                                    {(candidate.education.filter((edu) => edu.isTraining == 1).length > 0) &&
                                      (<div className="tab-pane" id="tab-training">
                                        {candidate.education.filter((edu) => { return edu.isTraining == 1; }).map((train, index) => (
                                          <Education key={index} {...train} />
                                        ))}
                                      </div>)}
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab>
                      {/* Education Tab Ends*/}

                      {/* Languages Tab Starts*/}
                      {languageLength > 0 ?
                        <Tab eventKey="languages" title={<span>Languages</span>}>
                          <div id="tab5">
                            <div className="panel panel-default">
                              <div id="collapseFive" className="panel-collapse collapse">
                                <div className="panel-body lang">
                                  {/* <h2>Languages</h2> */}
                                  {(candidate.languages.length > 0) ? candidate.languages.map((lang, index) => (
                                    <Languages key={index} {...lang} />
                                  )) : noDataString}
                                </div>
                              </div>
                            </div>
                          </div>
                        </Tab> : ""}
                      {/* Languages Tab Ends*/}

                      {/* Hobbies Tab Starts*/}
                      {(candidate.hobbies.length > 0) ?
                        <Tab eventKey="hobbies" title={<span>Interests</span>}>
                          <div id="tab6">
                            <div className="panel panel-default">
                              <div className="panel-heading">
                                <h4 className="panel-title">
                                  <a data-toggle="collapse" data-parent=".tab-pane" href="#collapseSix">
                                    Interests
                            </a>
                                </h4>
                              </div>
                              <div id="collapseSix" className="panel-collapse collapse">
                                <div className="panel-body hob">
                                  {candidate.hobbies.map((hobby, index) => (
                                    <Hobby key={index} hobby={hobby} />
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </Tab>
                        : ""}
                      {/* Hobbies Tab Ends*/}
                    </Tabs>
                  </MediaQuery>
                  {/*Impleneting bootstrap tab end */}
                </Tab>
                {(this.props.talentPool.companyType === 1) ?
                  <Tab eventKey={2} title="Scoring">
                    <div className="profile-scoring-cont">
                      <ProfileScoring
                        candidate={candidate}
                        jobTitleId={this.props.jobTitleId}
                        candidate_status={candidate.candidate_status}
                        candidatePhoto={this.state.candidatePhoto}
                        isS3Url={(this.state.candidatePhoto !== null) ? true : false}
                        handleRegret={this.handleRegret}
                        handleProgress={this.handleProgress}
                      />
                    </div>
                  </Tab>
                  :
                  <Tab eventKey={2} title="Feedback">
                    <div className="Feedback-section">
                      <Feedback
                        candidate={candidate}
                        jobTitleId={this.props.jobTitleId}
                        candidate_status={candidate.candidate_status}
                        candidatePhoto={this.state.candidatePhoto}
                        isS3Url={(this.state.candidatePhoto !== null) ? true : false}
                        handleFeedBackStatus={this.handleFeedBackStatus}
                        handlesaveFeedbackComment={this.handlesaveFeedbackComment}
                      />
                    </div>
                  </Tab>
                }
              </Tabs>
            </div>
        }
        {
          <MediaQuery query="(max-device-width: 769px)">
            <iframe id="ifmcontentstoprint" style={{
              height: '0px',
              width: '0px',
              position: 'absolute',
              size: 'A4',
              margin: '0',
            }}>
              <html>
                <head>
                  <link href="../../../components/Client/CandidateProfilePage/PrintCandidateProfile/printCandidatePreview.css" rel="stylesheet" ></link>
                </head>
                <body>
                  <div id="print-content" style={{ display: 'none' }}>
                    <PrintCandidateProfile id={this.props.activeCandidateId} />
                  </div>
                </body>
              </html>
            </iframe>
          </MediaQuery>
        }
        <ToastNotification
          isShowToast={this.state.isShowToast}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          autoClose={this.state.toastAutoClose}
          onClose={this.handleCloseToastNotification}
          toastId={this.state.toastId}
        />
      </div >

    );
  }
}

/**
* @desc connecting to redux store
* @param state
* @return redux state
*/
const mapStateToProps = state => {
  return {
    pool: state.talentPool.pool,
    profileInfo: state.candidateProfile.profileInfo,
    activeCandidateId: state.talentPool.activeCandidateId,
    jobTitleId: state.talentPool.jobTitleId,
    user: state.cognito.user,
    attributes: state.cognito.attributes,
    talentPool: state.talentPool
  };
}
/**
* @desc connecting to redux actions
* @param dispatch
* @return redux actions
*/
const mapDispatchToProps = dispatch => {
  return {
    onGetProfileDetails: (canidateId, jobTitleId, isClient, user) => dispatch(actions.getProfileDetails(canidateId, jobTitleId, isClient, user)),
    onGetTalentPool: (jobTitleId, user) => dispatch(actions.getTalentPool(jobTitleId, user)),
    onUpdateCandidateStatus: (candidateId, candidateStatus) => dispatch(actions.setStatus(candidateId, candidateStatus))
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(Profile, axios));




// WEBPACK FOOTER //
// ./src/container/Client/CandidateProfile/Profile.js